import { ErrorSeverity, ErrorSeverityType } from '@/core/misc/ErrorSeverity';

/**
 * Базовый класс клиентской ошибки приложения — аналог ApplicationException на беке.
 *
 * Не бросать напрямую — использовать наследников:
 * - ValidationError         — ожидаемое нарушение бизнес-правил
 * - CriticalValidationError — рассинхрон данных, нарушение инварианта
 */
class ApplicationError extends Error {

    public readonly code: number;
    public readonly severity: ErrorSeverityType;
    public readonly debugData: unknown;

    constructor(message: string, code: number, severity: ErrorSeverityType, debugData: unknown = null) {
        super(message);
        this.name      = 'ApplicationError';
        this.code      = code;
        this.severity  = severity;
        this.debugData = debugData;
    }

    /**
     * Создаёт ApplicationError из серверной RPC ошибки.
     * Позволяет обрабатывать серверные и клиентские ошибки единообразно.
     */
    static fromRpcError(rpcError: any): ApplicationError {
        const severity: ErrorSeverityType = rpcError?.severity === ErrorSeverity.Error
            ? ErrorSeverity.Error
            : rpcError?.severity === ErrorSeverity.Warning
                ? ErrorSeverity.Warning
                : ErrorSeverity.Notice;

        return new ApplicationError(
            rpcError?.message ?? 'Неизвестная ошибка сервера',
            rpcError?.code ?? 0,
            severity,
            rpcError?.debugData ?? null,
        );
    }
}

export default ApplicationError;